<ic-auth-wrapper>
	<p class="mb-8" data-test="problem-message">{{ labelKey() | translate }}</p>
	<ui-button class="btn-action" data-test="close-button" (click)="goToLogin()">{{
		"actions.close" | translate
	}}</ui-button>
</ic-auth-wrapper>
